module.exports = __webpack_public_path__ + "img/7.ae9d3df0.png";